module.exports = __webpack_public_path__ + "img/1410127155.3a2d6c57.jpg";